import { currencyFormatterNoCents } from './currencyFormatterNoCents';
import { isNonEmptyString } from './isNonEmptyString';
import { toNumericString } from './toNumericString';

export const toCurrencyString = (value?: string | number | null): string => {
  const valueAsString = toNumericString(value);

  return isNonEmptyString(valueAsString)
    ? currencyFormatterNoCents.format(Number(valueAsString))
    : '';
};
